import { BBUILocale, BBUILocales } from './types';

function isI18nLocale(locale: string): locale is BBUILocale {
    return BBUILocales.includes(locale as BBUILocale);
}

export function makeBBUILocale(locale: string): BBUILocale {
    let bbLocale: string;
    const lowerCaseLocale = locale.toLowerCase();
    if (['zh-hk', 'zh-tw'].includes(lowerCaseLocale)) {
        bbLocale = 'zt';
    } else {
        bbLocale = locale.split('-')[0]; // "en-US" -> "en"
    }

    return isI18nLocale(bbLocale) ? bbLocale : 'en';
}
